<h1 mat-dialog-title> Detalle Beneficiario </h1> <br/>

<mat-dialog-content>
    
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Nombre </mat-label>
            
            <input matInput placeholder = "Comentario Rechazo" [(ngModel)] = "data.nombre" required [disabled] = "true"> 

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">
            
            <mat-label> Teléfono Fijo </mat-label>
            
            <input matInput placeholder = "Telefono Fijo" [(ngModel)] = "data.telefono" required [disabled] = "true"> 
            
        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">
            
            <mat-label> Teléfono Móvil </mat-label>
            
            <input matInput placeholder = "Telefono Movil" [(ngModel)] = "data.celular" required [disabled] = "true"> 
            
        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">
            
            <mat-label> Mail </mat-label>
            
            <input matInput placeholder = "Mail" [(ngModel)] = "data.mail" required [disabled] = "true"> 
            
        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">
            
            <mat-label>Sistema de Salud </mat-label>
            
            <input matInput placeholder = "Sistema de Salud" [(ngModel)] = "data.prevision" required [disabled] = "true"> 
            
        </mat-form-field>
    </p>

    <p *ngIf = "data.beneficiarios"> <mat-label> <h2> Beneficiarios </h2> </mat-label> </p>
    
    <table class = "table" *ngIf = "data.beneficiarios">
            
        <thead style = "background-color: #0f69b4;color:white;">
    
            <tr> <th> Rut </th> <th> Nombre y Apellido </th> <th> Parentesco </th> </tr>

        </thead>
        
        <tbody>

            <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let beneficiario of data.beneficiarios; let i = index">
                
                <td> {{beneficiario.rut}} - {{beneficiario.dv}} </td>
                <td> {{beneficiario.nombres}} {{beneficiario.apellidoPaterno}} </td>
                <td> {{beneficiario.parentesco}} </td>

            </tr>
    
        </tbody>

    </table>        

</mat-dialog-content>

<div mat-dialog-actions>

    <button mat-button class = "mat-raised-button btn-dark mat-button" (click) = "onCancelarClick()"> 
        <i class = "fa fa-sign-out-alt"> </i> Salir
    </button>
    
</div>